import { Box } from '@mui/material'
import { ProgressReportsOverview } from './ProgressReportsOverview'
import { Route, Routes } from 'react-router-dom'
import { OrgProgressReports } from './ProgressReports'
import { MidYear } from './MidYear/MidYear'
import { MidYearSummary } from './MidYear/Summary/MidYearSummary'

export const ProgressReportsTab = (): JSX.Element => {
  return (
    <Box>
      <Routes>
        <Route path="/" element={<ProgressReportsOverview />} />
        <Route path="/Organization/:planOrgId" element={<OrgProgressReports />} />
        <Route path="/Organization/:planOrgId/MidYear" element={<MidYear/>} />
        <Route path="/Organization/:planOrgId/MidYear/Summary" element={<MidYearSummary/>} />
      </Routes>

    </Box>
  )
}
